// Date 2021-06-09 10:13:09

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";
// import emWorkflowListView from "@/components/em/EmWorkflow/ListView";
// import emWorkflowTaskView from "@/components/em/EmWorkflow/TaskView";
// import emLevelTreeListView from "@/components/em/EmLevelTree/ListView";

import emRunning from "@/views/em/kpiLayout/emRunning.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册

//自定义页面注册

    //emAcctStatistics
    {
        path: "/em/kpiLayout/emRunning",
        name: "emRunning",
        component: emRunning,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    }
]